<template>
  <div id="error-setting-input-dialog">
    <v-dialog
      v-model="inputDialog"
      persistent
      @input="v => v || clearInput()"
      width="600"
    >
      <v-card>
        <v-card-title>検知文字追加</v-card-title>
        <v-textarea
          v-model="errorSettingInput.detectKeyword"
          label="検知文字"
          clearable
          auto-grow
          rows="1"
          no-resize
          counter="50"
          maxlength="50"
          class="px-5 pb-5"
        ></v-textarea>
        <v-select
          v-model="errorSettingInput.useTypeCode"
          :items="useTypeList"
          item-text="name"
          item-value="code"
          label="対象サーバ"
          class="px-5 pb-5"
        ></v-select>
        <v-card-actions class="px-5 pb-5">
          <v-btn color="primary" @click="inputDialog = false" width="100"
            >キャンセル</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn color="secondary" @click="registerErrorSetting()" width="100"
            >登録</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script lang="ts">
import {
  Component,
  Vue,
  PropSync,
  Emit,
  Prop,
  Watch
} from "vue-property-decorator";
import { UseTypeList } from "../store/UseTypeModule";

@Component
export default class ErrSttInputDialog extends Vue {
  /** ダイアログ表示フラグ */
  @PropSync("inputDialogFlag", { type: Boolean, default: false })
  inputDialog!: boolean;

  /** 障害設定情報の入力値 */
  @PropSync("errorSettingInputData", { type: Object })
  errorSettingInput!: {
    detectKeyword: string | null;
    useTypeCode: number | null;
  };

  /** 用途種別リスト */
  @Prop({ type: Array })
  useTypeList!: UseTypeList;

  /**
   * 障害設定情報をDBに登録する際の処理
   * ※登録処理は親コンポーネントの関数で行う。
   */
  @Emit("registerErrorSetting")
  registerErrorSetting(): void {
    return;
  }

  /**
   * ダイアログを閉じた際に入力値を初期化
   */
  @Watch("inputDialog")
  clearInput(): void {
    this.errorSettingInput.detectKeyword = null;
    this.errorSettingInput.useTypeCode = null;
  }
}
</script>

<style lang="scss" scoped>
@import "@/scss/common.scss";
</style>
